module.exports = "https://web-assets.ifttt.com/packs/media/layout/chevron-right-gray-052683c1.svg";